import React, { useState, useCallback } from 'react'
import Dialog from '~shared/lib/Dialog/Dialog'

type WeightedItem = {
  quantity: number
}

type WeightDiscrepancyModalProps = {
  display: boolean
  onApprove: () => void
  onReject: () => void
}

const WeightDiscrepancyModal = ({ display, onApprove, onReject }: WeightDiscrepancyModalProps) => {
  if (!display) return null

  // Render the modal with approval and rejection handling
  return (
    <Dialog
      header={`Weight Confirmation`}
      autoFocus={true}
      action={onApprove}
      actionButtonLabel="Yes"
      toggleDialog={onReject}
      cancelButtonLabel="No"
    >
      Weight change is greater than 30% confirm this is correct?
    </Dialog>
  )
}

export const useWeightedItemValidator = () => {
  const [item, setItem] = useState<WeightedItem | null>(null)
  const [weight, setWeight] = useState<number | null>(null)
  const [displayModal, setDisplayModal] = useState(false)
  const [approval, setApproval] = useState<(result: boolean) => void>(() => {})

  const handleSubmitApproval = useCallback(
    (result: boolean) => {
      setApproval(() => () => {})
      setDisplayModal(false)
      approval(result)
    },
    [approval]
  )

  const weightedItemValidator = async (item: WeightedItem, weight: number): Promise<boolean> => {
    setItem(item)
    setWeight(weight)
    if (item.quantity > 0 && (weight > item.quantity * 1.3 || weight < item.quantity * 0.7)) {
      // Display modal and set up a new promise for resolution
      return new Promise<boolean>((resolve, reject) => {
        setApproval(() => resolve)
        setDisplayModal(true)
      })
    } else {
      return Promise.resolve(true) // If conditions are not met, immediately resolve as true
    }
  }

  return {
    weightedItemValidator,
    WeightDiscrepancyModal: () => (
      <WeightDiscrepancyModal
        display={displayModal}
        onApprove={() => handleSubmitApproval(true)}
        onReject={() => handleSubmitApproval(false)}
      />
    ),
  }
}
